import instance from "../../helpers/AxiosInterceptor";

export const loadEncheres = (status) => {
  const query = status ? `?status=${status}` : "";
  return instance.get(`/encheres${query}`);
};

export const saveEnchere = (request) => {
  return instance.post("/encheres", JSON.stringify(request));
};

export const deleteEnchere = (id) => {
  return instance.delete(`/encheres/${id}`);
};

export const loadVisibleEncheres = (ferrailleurId) => {
  const query = ferrailleurId ? `?ferrailleurId=${ferrailleurId}` : "";
  return instance.get(`/encheres/visibles${query}`);
};

export const loadMesAchats = (ferrailleurId) => {
  const query = ferrailleurId ? `?ferrailleurId=${ferrailleurId}` : "";
  return instance.get(`/encheres/achats${query}`);
};
